// extracted by mini-css-extract-plugin
export default {"layout":"layout___ZMvBL","authorImage":"authorImage___XZ8_L","authorInfo":"authorInfo___oaUFr","description":"description___M7Ev8"};